var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18468)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10487_18468)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18468)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0008,
    height: 24.0008,
    rx: 12.0004,
    fill: "#CCCEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1669,
    y: 12.5671,
    width: 7.60026,
    height: 1.9334,
    rx: 0.966699,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.200007
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18468)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.93412,
    y: 20.1915,
    width: 14.4672,
    height: 15.3338,
    rx: 7.23358,
    transform: "rotate(-16 2.93412 20.1915)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.200007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.83377,
    y: 16.2339,
    width: 4.0668,
    height: 1.9334,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.200007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.93372,
    y: 16.1339,
    width: 3.8668,
    height: 2.66676,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.9003,
    y: 7.50021,
    width: 6.13354,
    height: 9.66699,
    rx: 3.06677,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.200007
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_10487_18468",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5249 18.7339C15.3938 19.7716 13.851 20.5905 11.9671 20.5905C10.0942 20.5905 8.55837 19.781 8.41179 18.7519C5.903 19.4704 4.06689 21.7812 4.06689 24.5209V29.0544H19.9341V24.5209C19.9341 21.7579 18.0665 19.4311 15.5249 18.7339Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5249 18.7339C15.3938 19.7716 13.851 20.5905 11.9671 20.5905C10.0942 20.5905 8.55837 19.781 8.41179 18.7519C5.903 19.4704 4.06689 21.7812 4.06689 24.5209V29.0544H19.9341V24.5209C19.9341 21.7579 18.0665 19.4311 15.5249 18.7339Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5249 18.7339L15.5778 18.541L15.3554 18.48L15.3265 18.7088L15.5249 18.7339ZM8.41179 18.7519L8.6098 18.7237L8.57743 18.4964L8.35672 18.5596L8.41179 18.7519ZM4.06689 29.0544H3.86689V29.2544H4.06689V29.0544ZM19.9341 29.0544V29.2544H20.1341V29.0544H19.9341ZM15.3265 18.7088C15.2727 19.1344 14.9211 19.5538 14.3104 19.8742C13.706 20.1913 12.8822 20.3905 11.9671 20.3905V20.7906C12.9359 20.7906 13.8255 20.5803 14.4962 20.2285C15.1606 19.8799 15.646 19.3711 15.7233 18.759L15.3265 18.7088ZM11.9671 20.3905C11.0574 20.3905 10.2378 20.1936 9.63436 19.8797C9.02461 19.5625 8.67002 19.1465 8.6098 18.7237L8.21378 18.7801C8.30014 19.3864 8.78674 19.8897 9.44977 20.2346C10.1191 20.5827 11.0039 20.7906 11.9671 20.7906V20.3905ZM4.2669 24.5209C4.2669 21.8728 6.04158 19.6388 8.46686 18.9442L8.35672 18.5596C5.76442 19.3021 3.86689 21.6896 3.86689 24.5209H4.2669ZM4.2669 29.0544V24.5209H3.86689V29.0544H4.2669ZM19.9341 28.8544H4.06689V29.2544H19.9341V28.8544ZM19.7341 24.5209V29.0544H20.1341V24.5209H19.7341ZM15.472 18.9268C17.929 19.6007 19.7341 21.8503 19.7341 24.5209H20.1341C20.1341 21.6655 18.2041 19.2614 15.5778 18.541L15.472 18.9268Z",
    fill: "#111111",
    mask: "url(#path-11-inside-1_10487_18468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6112 10.6532C15.6112 8.07645 14.1897 6.33356 12.4582 6.33356C10.24 6.33356 7.97998 7.16564 7.97998 11.1002C7.97998 12.0736 8.05249 12.7991 8.63365 13.3338C8.70032 13.3951 8.87153 13.5289 8.84035 13.4752C8.72764 12.4232 9.54401 11.8903 10.7671 11.1002C11.4163 10.6807 12.7671 9.90034 13.2671 9.50033C13.6412 9.71231 14.3914 10.3147 14.6008 10.6738C14.7132 10.8664 14.8936 11.5265 15.0169 12.2969C15.42 11.8128 15.6112 11.3284 15.6112 10.6532Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.256139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9418 9.18934C13.4554 8.72364 14.2238 7.66074 14.1745 6.9704",
    stroke: "#111111",
    strokeWidth: 0.256139
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 23.1008,
    height: 23.1008,
    rx: 11.5504,
    stroke: "white",
    strokeWidth: 0.9
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 23.1,
    height: 23.1,
    rx: 11.55,
    stroke: "white",
    strokeWidth: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10487_18468",
    x: -20,
    y: -10,
    width: 64.0009,
    height: 64.0008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.113725 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_18468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_18468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0008,
    height: 24.0008,
    rx: 12.0004,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6672,
    height: 21.3341,
    fill: "white",
    transform: "translate(4.66687 1.60004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric11);
export default __webpack_public_path__ + "static/media/Generic 11.7eec4a04257258ef2d4feb37ee769a99.svg";
export { ForwardRef as ReactComponent };